/* tempexp_18086-start */
import { Text } from '@vkontakte/vkui';
import React, { type ReactNode } from 'react';

import styles from './ReferralInfoItem.css';

interface ReferralInfoItemProps {
    icon: ReactNode;
    title: string;
    description: string;
}

export function ReferralInfoItem({ icon, title, description }: ReferralInfoItemProps) {
    return (
        <div className={styles.root}>
            {icon}
            <div className={styles.info}>
                <Text className={styles.title}>{title}</Text>
                <Text className={styles.description}>{description}</Text>
            </div>
        </div>
    );
}

/* tempexp_18086-end */
